import React from 'react';

import PropTypes from 'prop-types';

import l10n from '../../../../shared/strings';
import TextFieldField from './TextFieldField';

const UrlField = ({ placeholder, textPlaceholder, ...props }) => (
  <TextFieldField
    {...props}
    placeholder={placeholder || textPlaceholder}
    fieldTooltip={l10n.PRODUCT_INFO.fieldHelpers.url}
  />
);

UrlField.propTypes = {
  data: PropTypes.shape({ title: PropTypes.string }).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  textPlaceholder: PropTypes.string,
  validate: PropTypes.func,
  savedError: PropTypes.string,
  onValidationChange: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

UrlField.defaultProps = {
  placeholder: '',
  value: '',
  disabled: false,
  isDiff: false,
  textPlaceholder: '',
  validate: null,
  savedError: null,
  onValidationChange: null,
};

export default UrlField;
